export default "/images/vendor/flag-icon-css/flags/1x1/re.svg?65fecda00937aa8b6917c3118f5d0457";